import React, { Component } from 'react';

import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { connect } from 'react-redux';
import { openDrawer, closeDrawer } from 'actions/drawer';
import { openModal } from 'actions/modal';
import Footer from 'components/AppFooter/AppFooter';
import { Link } from 'react-router';

import { firebaseConnect, helpers } from 'react-redux-firebase';
const { isLoaded, dataToJS, pathToJS } = helpers;

import {CSVLink} from 'react-csv';
import PQMetricsList from '../../components/MetricsList/PQMetricsList';
import PQ2MetricsList from '../../components/MetricsList/PQ2MetricsList';
import PhonemeFarmMetricsList from 'components/PhonemeFarmMetricsList';
import MetricsKey from 'components/Metrics/MetricsKey';
import ContentHeader from 'components/ContentHeader';
import Loader from 'components/Loader/Loader';
import PencilIcon from 'assets/icons/pencil';
import InlineSVG from 'svg-inline-react';
import StudentNotes from 'components/StudentNotes';
import { keyedObjToArr } from '../../util';
import { generateCSVPQ1, generateCSVPQ2, generateCSVPF } from '../../util/csv';


class StudentMetrics extends Component {

	constructor (props) {
		super(props);
		this.state = {
            studentId : this.props.params.studentId,
            classroomId : this.props.params.classroomId
		};
	}

    updateNotes(student, notes){
        const { firebase } = this.props;
        firebase.set(`/classrooms/${this.state.classroomId}/students/${this.state.studentId}/notes`, notes);
    }

    notes(student){
        let notes = (<StudentNotes
			student={student}
			updateNotes={this.updateNotes.bind(this)}
		/>);

        this.props.openModal(notes, {
                title : `Notes for ${student.name}`,
                className: 'notes-modal',
                onClose : (result) => { }
            }
        );

        this.props.openModal();
    }

	render () {



        if( !isLoaded(this.props.profile) ||
            !isLoaded(this.props.classrooms) ||
			!isLoaded(this.props.orders) ||
			!isLoaded(this.props.customers) ||
			!isLoaded(this.props.schools) ||
			!isLoaded(this.props.products)) {
            return (
				<div className="main-content-area">
					<div className="page-content">
						<Loader color="main" size="large" />
					</div>
					<Footer/>
				</div>
            );
        }

        if(!this.props.params || !this.props.params.studentId || !this.props.params.classroomId){
            return(
                <div>TODO: Classroom and Student Picker</div>
			);
		}

        let student;

        if(!this.props.classrooms){
			return(<div className="main-content-area">
				<div className="page-content">
					<Loader color="main" size="large" />
				</div>
				<Footer/>
			</div>);
		}

		let classroom = keyedObjToArr(this.props.classrooms).find( (classroomItem) => {
			return classroomItem.id === this.state.classroomId;
		}, this);


		if(classroom) {
            student = keyedObjToArr(classroom.students).find((studentItem) => {
                return studentItem.id === this.state.studentId;
            }, this);
        }
        else{
			return(<div className="main-content-area">
				<div className="page-content">
					<div><h3>No Student Loaded</h3></div>
				</div>
			</div>);
		}


        let classrooms;
        let profile;

        //Not admin and not customer
        if(!this.props.profile.customer && this.props.profile.role !== 'admin') {

            return(
				<div className="main-content-area">
					<div className="page-content">
						<div><h3>No Customer for User</h3></div>
					</div>
				</div>
            );
        //Teacher and Not Admin
        } else if(this.props.profile.classrooms && this.props.profile.role === 'teacher') {

            profile = this.props.profile;

            classrooms = keyedObjToArr(profile.classrooms).map( (classroom) => {
                if(!this.props.classrooms[classroom.id]) {
                    console.warn('couldnt find classrom with id ' + classroom.id);
                }
                return this.props.classrooms[classroom.id];
            });

            // Admin
        } else if(this.props.profile.role === 'admin') {
            classrooms = keyedObjToArr(this.props.classrooms);
        }

        let link = (<Link to={{
            pathname: `/metrics/${classroom.id}`
		}}> Back to Classroom</Link>);

        let csvData;
        let metricsList = null;
        switch(classroom.product){
            case 'pupsquestforphonicsschool1':
                metricsList = (<PQMetricsList
                    profile={profile}
                    classroom={classroom}
                    student={student}
                    classrooms={this.props.classrooms}
                    studentId={this.state.studentId}
                    classroomId={this.state.classroomId}
                />);
                csvData = generateCSVPQ1(classroom, [student]);
                break;
            case 'phonemefarmschool':
                metricsList = (<PhonemeFarmMetricsList
                    profile={profile}
                    classroom={classroom}
                    student={student}
                    classrooms={this.props.classrooms}
                    studentId={this.state.studentId}
                    classroomId={this.state.classroomId}
                    customer={this.props.customer}
                    users={this.props.users}
                    schools={this.props.schools}
                    products={this.props.products}
                    orders={this.props.orders}
                />);
                csvData = generateCSVPF(classroom, [student]);
                break;
            case 'pupsquestforphonicsschool2':
                metricsList = (<PQ2MetricsList
                    profile={profile}
                    classroom={classroom}
                    student={student}
                    classrooms={this.props.classrooms}
                    studentId={this.state.studentId}
                    classroomId={this.state.classroomId}
                />);
                csvData = generateCSVPQ2(classroom, [student]);
                break;
        }

        let headerComponent = (
            <span className='metrics'>
                <span className="button notes"
                      onClick={this.notes.bind(this, student)}
                >
                    <span className="notes-icon">
                        <InlineSVG src={PencilIcon} element="span" className="icon" />
                    </span>
                    <span className="label">
                        Notes
                    </span>
                </span>
                {csvData && (
                    <span className="button download">
                        <span className="label">
                            <CSVLink
                                filename={`csv_${student.name}_${classroom.name}.csv`}
                                data={csvData}
                                separator=','
                                className='notes-label'
                            >
                                Download
                            </CSVLink>
                        </span>
                    </span>
                )}
            </span>

        );

		return (
			<ReactCSSTransitionGroup
				transitionName="main-content"
				transitionAppear={true}
				transitionAppearTimeout={1500}
				transitionEnterTimeout={1500}
				transitionLeaveTimeout={1500}
				className="main-transition-wrap"
			>
				<div className="main-content-area" key="metrics">
					<ContentHeader
						title={`Metrics - ${student.name}`}
						leftComponent={headerComponent}
						component={<MetricsKey />}
						link={link}
					/>
					<div className="page-content">
						<div className="container">
							<div className="row">
								<div className="col-12">
									<div className="student-metrics">
                                        {metricsList}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</ReactCSSTransitionGroup>
		);
	}
}


const mapDispatchToProps = (dispatch) => {
	return {
		openDrawer :  (id) => { dispatch(openDrawer(id)); },
		closeDrawer : () => { dispatch(closeDrawer()); },
		openModal : (modal, props) => { dispatch(openModal(modal, props)); }
	};
};

const fbWrappedComponent = firebaseConnect( ({auth, profile}) => {
	if(!profile){
		return [];
	} else {
        return [
			{
                path: 'classrooms',
                storeAs: 'classrooms'
            },
			{
				path: 'products',
				storeAs: 'products'
			},
			{
				path: 'orders',
				storeAs: 'orders'
			},
			{
				path: 'schools',
				storeAs: 'schools'
			},
			{
				path: 'customers',
				storeAs: 'customers'
			}
        ];
	}
})(StudentMetrics);

//Auth
const connectAuth = connect(
    ({ firebase }) => {
        return{
            profile: pathToJS(firebase, 'profile'),
        };
    }
)(fbWrappedComponent);

export default connect(
    ({ firebase }) => ({
        classrooms: dataToJS(firebase, 'classrooms'),
		products : dataToJS(firebase, 'products'),
		orders : dataToJS(firebase, 'orders'),
		schools : dataToJS(firebase, 'schools'),
		customers : dataToJS(firebase, 'customers')
    }),
    mapDispatchToProps
)(connectAuth);



// WEBPACK FOOTER //
// ./js/containers/StudentMetrics/StudentMetrics.js